import {
	createContext,
	type FC,
	type PropsWithChildren, type RefObject,
	useContext,
	useRef,
} from "react";

type ScrollListContextType = {
	enabled?: boolean;
	hasScrolledRef: RefObject<boolean>;
};
interface ScrollListProviderProps{
	scrollToProduct?: boolean;
}
const ScrollListContext = createContext<ScrollListContextType | undefined>(undefined);
export const ScrollListProvider: FC<PropsWithChildren<ScrollListProviderProps>> = ({ children }) => {
	const hasScrolledRef = useRef(false);

	return (
		<ScrollListContext.Provider
			value={{
				hasScrolledRef
			}}
		>
			{children}
		</ScrollListContext.Provider>
	);
};

export const useScrollList = () => {
	const context = useContext(ScrollListContext);
	if (!context) throw new Error("useScrollTo must be used within a UIProvider");
	return context;
};
